import type { RouteObject } from 'react-router'

/**
 * Creates routes for the documents feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '/documents/*',
      lazy: {
        Component: () =>
          import('@/features/documents/components/DocumentRoot/DocumentRootContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
